import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export { config as acquisitionNewsletterPopupThemeConfig } from "./config";
export * from "./hooks";
export const AcquisitionNewsletterPopupTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "acquisition-newsletter-popup-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
AcquisitionNewsletterPopupTheme.displayName = "AcquisitionNewsletterPopupTheme";